 
<template>
  <!-- <a-row :gutter="8">
  <a-col :span="24">-->
  <div class="w-full">
    <div class="table-operator">
      <a-button @click="handleTableAdd" icon="plus" type="primary" v-if="treeSelectInfo.isLeaf">新增</a-button>
      <a-button @click="handleTableSave" icon="save">保存</a-button>
      <!-- <a-dropdown v-if="selectedRowKeys.length>0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
          <a-menu-item @click="batchCopy" key="2">
            <a-icon type="download" />导出
          </a-menu-item>
          <a-menu-item @click="batchCopy" key="3">
            <a-upload
              :action="importExcelUrl"
              :headers="tokenHeader"
              :multiple="false"
              :showUploadList="false"
              @change="handleImportExcel"
              name="file"
            >
              <a-icon type="import" />导入
            </a-upload>
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>-->
    </div>
    <j-vxe-table
      :columns="tableColumns"
      :dataSource="dataSource"
      :height="484"
      :linkageConfig="linkageConfig"
      :loading="loading"
      :pagination="pagination"
      @edit-closed="handleEditClosed"
      @edit-disabled="editDisabledEvent"
      @pageChange="handlePageChange"
      @selectRowChange="handleSelectRowChange"
      keep-source
      ref="vTable"
      row-selection
      v-if="!modelLoading"
    >
      <!--            @edit-closed="handleEditClosed"
  @valueChange="valueChange"
      -->
      <template v-slot:action="props">
        <a-button @click="handleCopy(props)" class="mr-10px" icon="copy" key="copy" size="small"></a-button>

        <a-popconfirm @confirm="handleDL(props)" title="确定删除吗？">
          <!-- <a-icon type="delete" /> -->
          <a-button icon="delete" key="delete" size="small" type="danger"></a-button>
        </a-popconfirm>
      </template>
    </j-vxe-table>
  </div>
  <!-- </a-col>
  </a-row>-->
</template>

<script>
  import { mapGetters } from 'vuex'
  import { JVXETypes } from '@/components/jeecg/JVxeTable'
  import { getAction, postAction } from '@/api/manage';
  import { deleteAction } from '../../../api/manage';

  export default {
    name: 'MainTenanceTable',
    props: {
      tableFillData: {
        type: Object,
        default: () => { }
      },
      devModelList: {
        type: Array,
        default: () => []
      },
      modelLoading: {
        type: Boolean,
        default: true
      },
      bpbjType: {
        type: String,
        default: '2'
      },
      treeSelectInfo: {
        type: Object,
        default: () => { }
      },
      queryParam: {
        type: Object,
        default: () => { }
      },
    },
    // 定义属性
    data () {
      return {
        selectedRows: [],
        // 是否正在加载
        loading: false,
        // 分页器参数
        pagination: {
          // 当前页码
          current: 1,
          // 每页的条数
          pageSize: 30,
          // 可切换的条数
          pageSizeOptions: ['10', '20', '30', '100', '200'],
          // 数据总数（目前并不知道真实的总数，所以先填写0，在后台查出来后再赋值）
          total: 0,
        },
        linkageConfig: [
          // { requestData: this.getDevTypeList, key: 'modelId' },
        ],
        dataSource: [

        ],
        queryParam1: this.queryParam,
        // queryParam: { devClassCodes: '', devModelId: '' },
        tableColumns: [
          {
            width: '180px',

            title: '备件名称',
            key: 'bjName',
            type: JVXETypes.input,
            // fixed: 'left',
            defaultValue: '',
            sortable: true
          },
          {
            width: '160px',

            title: '备件型号',
            key: 'bjModel',
            type: JVXETypes.input,
            // fixed: 'left',
            defaultValue: '',
            sortable: true
          },
          {
            width: '140px',

            title: '备件规格',
            key: 'bjModelSpec',
            type: JVXETypes.input,

            defaultValue: '',
            sortable: true
          },
          {
            width: '220px',
            title: '生产厂家',
            key: 'manuId',
            type: JVXETypes.selectSearch,
            // dictCode: '`iwt-wf`.common_manufacturer,manu_name,id, 1=1 order by manu_name asc',
            defaultValue: '2',
            align: 'center',
            options: this.manuList,
            sortable: true
          },
          /* {
            width: '180px',

            title: '生产厂家',
            key: 'manuName',
            // type: JVXETypes.input,

            defaultValue: '',
            sortable: true
          }, */
          {
            width: '80px',

            title: '单位',
            key: 'unit',
            type: JVXETypes.select,
            dictCode: 'asset_unit',
            defaultValue: '1',
            align: 'center',
            sortable: true
          },
          {
            title: '备件类型',
            key: 'bpbjType',
            dictCode: 'bpbj_type',
            type: JVXETypes.select,
            width: '150px',
            placeholder: '请选择',
            align: 'center',
            validateRules: [
              {
                required: true, // 必填
                message: '请输入${title}' // 显示的文本
              }
            ],
            sortable: true,
            disabled: true
          },
          {
            title: '适配设备类型',
            key: 'devClassCode_dictText',
            type: JVXETypes.normal,
            width: '180px',
            align: 'center',
            sortable: true,
          },
          {
            title: '适配设备型号',
            key: 'devModelId',
            type: JVXETypes.selectMultiple,
            showSearch: true,
            defaultActiveFirstOption: 'false',
            validateRules: [
              {
                required: true, // 必填
                message: '请输入${title}' // 显示的文本
              }
            ],
            width: '180px',

            // dev_model
            // dictCode: "`iwt-wf`.dev_model,model_name,id",
            defaultValue: '',
            options: this.devModelList,
            // width: '180px',
            placeholder: '请选择${title}',
            sortable: true
          },
          {
            title: '适配设备类型',
            key: 'devClassCode',
            type: JVXETypes.hidden,
            width: '180px',
            align: 'center',
            sortable: true,
          },
          {
            width: '100px',

            title: '寿命(月)',
            key: 'ageMonth',
            type: JVXETypes.inputNumber,
            align: 'center',
            // 表单验证规则
            validateRules: [
              {
                pattern: /^\+?[1-9]\d*$/, // 正则
                message: '${title}必须正整数'
              }
            ],
            defaultValue: '',
            sortable: true
          },
          {
            title: '操作',
            key: 'action',
            type: JVXETypes.slot,
            fixed: 'right',
            width: '130px',
            // minWidth: '60px',
            align: 'center',
            slotName: 'action',
          }
        ],
        manuList: [],
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters(['username']),
      selectedRowKeys () {
        return this.$refs?.vTable.getSelection() ?? []
      },
      // xTable refs
      xTable () {
        return this.$refs?.vTable.$refs?.vxe.$refs.xTable ?? null
      }
    },
    // 监控data中的数据变化
    watch: {
      devModelList: {
        immediate: true,
        handler (value, old) {
          // refreshColumn
          this.$set(this.tableColumns, 7, { ...this.tableColumns[7], options: this.devModelList })
        }
      },
      modelLoading: {
        handler (value, old) {
          if (!value) {
            this.$nextTick(() => {
              this.$set(this.tableColumns, 7, { ...this.tableColumns[7], options: this.devModelList })
              this.$set(this.tableColumns, 3, { ...this.tableColumns[3], options: this.manuList })
            })
          }
        }
      },
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    async created () {
      // this.loadData()
      const manuList = await getAction('/device/commonManufacturer/selectDropList', {
        pageSize: 9999,
        pageNo: 1,
      })
      this.manuList = manuList.result.records.map((item) => {
        item.value = item.id
        item.label = item.manuName
        return item
      })
      this.$nextTick(() => {
        this.$set(this.tableColumns, 7, { ...this.tableColumns[7], options: this.devModelList })
        this.$set(this.tableColumns, 3, { ...this.tableColumns[3], options: this.manuList })
      })
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {
    },
    // 方法集合
    methods: {
      async getDevTypeList (code) {

        const queryCode = code ?? this.tableFillData?.devModelId

        return []
      },
      async handleEditClosed (rows, v) {
        console.info('editRows=====', rows)
        console.info('editRows vvv=====', v)
        const { $table, col, value, type, column, row, rowId = '' } = rows
        // 判断单元格值是否被修改
        let field = column.property
        if (!$table.isUpdateByRow(row, field)) {
          return
        }
        /* if (column.key == "devModelId") {
          const { success, result } = await getAction('/device/devModel/queryByDevTypeId', { devModelId: row.devModelId })
          if (success) {
            const { manuName = '', manuId = '' } = result
            // this.$nextTick(() => {
            this.$refs.vTable.setValues([
              {
                rowKey: row.id,
                values: {
                  'manuName': manuName,
                  'manuId': manuId
                }
              },
            ])

          }
        } */
        if (row.id.indexOf('row') < 0) {
          this.xTable?.validate(row).then((errMap) => {
            // 校验通过
            if (!errMap) {
              this.loading = true
              const fields = this.tableColumns.map(item => item.key)
              const params = this.$Jlodash.pick(row, fields)
              postAction('/spareparts/devBpbjStandardInfo/edit', { ...params, id: row.id }).then(res => {
                if (res.success) {
                  this.$message.success('编辑成功')
                  this.loadData()
                }
              }).finally(() => {
                this.loading = false
              })
            }
          })
        }
      },
      async loadData () {

        const params = {
          pageNo: this.pagination.current,
          pageSize: this.pagination.pageSize,

          ...this.queryParam1
        }
        console.info('queryParam1===', params, this.queryParam1)
        if (this.bpbjType && this.bpbjType == 'zy') {
          params.bpbjType = '2'
        } else if (this.bpbjType && this.bpbjType == 'qt') {
          params.bpbjType = '1,3,4'
        }
        getAction('/spareparts/devBpbjStandardInfo/queryBpbjStandardByDevTypeIds', params).then(res => {
          if (res.success) {
            this.pagination.total = res.result.total
            this.dataSource = res.result.records.map((item) => {
              return {
                ...item,
                // devModelId: item.devModelId_dictText,
                manuName: item.manuId_dictText
              }
            })
            this.selectedRows = []
          }
        }).finally(() => {
          this.loading = false
        })
      },
      reloadTableData (query) {
        this.pagination.current = 1

        this.queryParam1 = { ...query }
        // this.$refs.vTable.initialize()

        this.loadData()
      },

      handleSelectRowChange (event) {
        this.selectedRows = event.selectedRows
      },
      // 当分页参数变化时触发的事件
      handlePageChange (event) {
        // 重新赋值
        this.pagination.current = event.current
        this.pagination.pageSize = event.pageSize

        // 查询数据
        this.loadData()
      },
      handleDL (v) {
        console.info('==========del', v);

        const { row, rowId } = v
        if (rowId.indexOf('row_') > -1) {
          this.$refs.vTable.removeRows(row)
          return
        }

        deleteAction('/spareparts/devBpbjStandardInfo/delete', { id: row.id }).then(res => {
          if (res.success) {
            this.$refs.vTable.removeRows(row)
            this.$message.success('删除成功')
          }
        })


      },
      handleTableSave () {
        // 校验整个表格
        const $table = this.$refs.vTable
        let newData = $table.getNewDataWithId()
        if (!newData.length) {
          this.$message.error('无新增数据！')
          return
        }
        // const xTable = this.$refs.vTable.$refs.vxe.$refs.xTable
        const resultRows = newData.map(item => this.$Jlodash.omit(item, ['id']))

        $table.validate(newData).then((errMap) => {

          //   // 校验通过
          if (!errMap) {
            // 获取新增的数据

            console.log('-- 新增的数据：', newData)
            this.loading = true
            postAction('/spareparts/devBpbjStandardInfo/batchAdd', resultRows).then(res => {
              if (res.success) {
                this.$message.success(`保存成功！`)
              } else {
                this.$message.warn(`保存失败：` + res.message)
              }
            }).finally(() => {
              this.loading = false
              this.loadData()
            })
          }
        })
      },
      handleTableAdd () {
        this.$refs.vTable.pushRows([{
          ...this.tableFillData,
          bpbjType: this.bpbjType == 'zy' ? '2' : '1',
          unit: '1',
          devClassCode_dictText: this.treeSelectInfo ? this.treeSelectInfo.title : '',
          devClassCode: this.treeSelectInfo ? this.treeSelectInfo.dev_class_code : '',
          devModelId: this.queryParam1.devModelId
        }], {
          index: 0,
          setActive: true,
        })
      },
      handleCopy (v) {
        const { row } = v
        this.$refs.vTable.addRows(this.$Jlodash.omit(row, ['id']))
      },
      handleTableModelChange (v) {
        console.info('modelChange', v)
      },
      //重新计算table
      async recalculateTable () {

      },
      // async valueChange (v) {

      async valueChange (rows) {
        console.info('========change', rows)
        const { col, value, type, column, row, rowId } = rows
        this.loading = true
        let editParams = {}
        if (col.field == "devModelId" && row.devModelId) {

          const { success, result } = await getAction('/device/devModel/queryBydevModelId', { devModelId: row.devModelId })

          if (success) {

            const { manuName = '', manuId = '' } = result
            // this.$nextTick(() => {
            this.$refs.vTable.setValues([
              {
                rowKey: row.id,
                values: {
                  'manuName': manuName,
                  'manuId': manuId
                }
              },
            ])
            editParams = {
              manuName,
              manuId
            }
            // })
          }
          this.loading = false
        }
        if (!type || ['manuName', 'manuId'].includes(col.field)) return

        if (row.id.indexOf('row') < 0) {

          postAction('/spareparts/devBpbjStandardInfo/edit', {
            id: row.id,
            [col.field]: value,
            ...editParams
          }).then(res => {
            if (res.success) {
              this.$message.success('编辑成功')

            }
          })
        }

      },
      editDisabledEvent ({ row, column }) {
      },
      async handleModeQuery (v, props) {
        // if (this.model.devModelId) this.model.devModelId = []
        this.devModelList = []
        const { success, result } = await getAction('/device/devModel/queryByDevClassId', {
          devClassCode: v
        })
        if (success) {
          this.devModelList = result
        }
        if (props) {
          this.handleEditClosed(props, props.row)
        }
      },
      manuSelected (e, record) {
        if (e && e.length == 1) {
          record.manuId_dictText = e[0].manuName
          record.manuName = e[0].manuName
        }
      },
    }
  }
</script>

<style lang='scss' scoped>


</style>